import { gql } from '@apollo/client'
import PropTypes from '~/lib/propTypes'

export const stateStepFragment = gql`
  fragment stateStep on DraftStateUnit {
    valid
    touched
    errors {
      code
      field
      message
      actions {
        label
        url
        variant
      }
    }
    warnings {
      code
      key
      message
    }
  }
`

export const stateStepFragmentPropTypes = PropTypes.shape({
  valid: PropTypes.bool.isRequired,
  touched: PropTypes.bool.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.oneOf([
        'DESCRIPTION_REQUIRED',
        'ATTACHMENT_REQUIRED',
        'ERROR',
        'INVALID_SELLING_PRICE',
        'UNAUTHORIZED_ACCESS',
        'NOT_BLANK',
        'INVALID_FORMAT',
        'FILE_ALREADY_ADDED_TO_DRAFT',
        'EXTERNAL_FILE_NOT_FOUND',
        'DRAFT_NOT_FOUND',
        'DISALLOWED_EMAIL_ADDRESS',
        'EVENT_COULD_NOT_BE_UPDATED',
        'EVENT_TYPE_NOT_FOUND',
        'MISSING_EVENT',
        'MISSING_EVENT_TYPE',
        'NOT_READY_TO_BE_PUBLISHED',
        'ORIGINAL_PRICE_MANDATED_BY_TICKET_PROVIDER',
        'MISSING_ORIGINAL_PRICE',
        'MISSING_SELLING_PRICE',
        'SELLING_PRICE_TOO_LOW',
        'SELLING_PRICE_TOO_HIGH',
        'SELLING_PRICE_BELOW_MINIMUM',
        'SELLING_PRICE_HIGHER_THAN_COUNTRY_LAWS',
        'SELLING_PRICE_HIGHER_THAN_OUR_PRICE_CAP',
        'SELLING_PRICE_CURRENCY_MISMATCH',
        'IBAN_INVALID_COUNTRY_CODE',
        'EMAIL_NOT_VERIFIED',
        'EVENT_NOT_ACTIVE',
        'EVENT_TYPE_EXPIRED',
        'MISSING_TICKETS',
        'MISSING_TICKETS_FOR_SALE',
        'MISSING_SEATING',
        'ATTACHMENTS_COUNT_DOES_NOT_MATCH_TICKETS',
        'MISSING_PROMOTION_TYPE',
        'PRIVATE_LISTING_CANT_BE_PROMOTED',
        'MISSING_KNOWN_BUYER_EMAIL',
        'KNOWN_BUYER_EMAIL_MATCHES_SELLER',
        'MISSING_USER_EMAIL',
        'MISSING_USER_PHONE',
        'USER_PHONE_NOT_VERIFIED',
        'USER_PAYOUT_METHOD_NOT_SET',
        'EVENT_BLOCKED_SELLING',
        'EVENT_TYPE_BLOCKED_SELLING',
        'TICKET_IS_SCAN',
        'TICKET_CONTAINS_ERRORS',
        'TICKET_UPLOAD_VERIFY',
        'FILE_CONTAINS_ERRORS',
        'VERIFICATION_ERROR',
        'VERIFICATION_INVALID_PDF',
        'VERIFICATION_USER_BLOCKED_SELLING',
        'VERIFICATION_USER_BANNED',
        'VERIFICATION_ATTACHMENTS_AS_ENTRANCE_TICKETS',
        'VERIFICATION_DUPLICATE_BARCODE',
        'VERIFICATION_INVALID_TICKETS',
        'VERIFICATION_ORIGINAL_PRICE_TOO_HIGH',
        'VERIFICATION_USER_IBAN',
        'MISSING_AVAILABLE_TICKETS_FOR_RESELL',
        'RESELLING_EVENT_NOT_FOUND',
        'RESELLING_EVENT_TYPE_NOT_FOUND',
        'DESCRIPTION_TOO_LONG',
        'SELLING_PRICE_CURRENCY_MISMATCH_GENERIC',
        'CAN_NOT_FIND_BARCODE',
        'PRICE_LOWER_THAN_ZERO',
        'CURRENCY_NOT_ALLOWED',
        'TICKET_CONTAINS_BLOCKED_KEYWORDS_LEGAL',
        'TICKET_CONTAINS_BLOCKED_KEYWORDS_GUESTLIST',
        'TICKET_CONTAINS_BLOCKED_KEYWORDS_MEMBERSHIP',
        'TICKET_CONTAINS_BLOCKED_KEYWORDS_LOCKER',
        'TICKET_CONTAINS_BLOCKED_KEYWORDS_PREVENTION',
        'NOT_OWNER_OF_TICKET_OR_LOCKED',
        'AMOUNT_OF_REQUIRED_TICKETS_IN_BUNDLE_NOT_IN_DRAFT',
        'TICKET_PROVIDER_USER_EMAIL_MISMATCH',
      ]),
      field: PropTypes.string,
      message: PropTypes.string,
    })
  ),
  warnings: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.oneOf([
        'USER_PHONE_VERIFICATION_SKIPPED',
        'USER_SOCIAL_ACCOUNTS_NOT_CONNECTED',
      ]),
      key: PropTypes.string,
      message: PropTypes.string,
    })
  ),
})
